/**
 * Constants for system settings configuration
 */

export const INPUT_TYPES = {
    CHECKBOX: 'checkbox',
    NUMBER: 'number',
    SELECT: 'select',
    TEXT: 'text',
};

export const RANGE_CONSTRAINTS = {
    TIMEOUT_MS: { min: 1000, max: 120000 },
    TTL_SECONDS: { min: 60, max: 604800 },
    VECTOR_K: { min: 100, max: 50000 },
    THRESHOLD: { min: 1, max: 10 },
    DOWNLOADS_LIMIT: { min: 1, max: 10000 },
    WEIGHT_BOOST: { min: 0.1, max: 10.0 },
    SCORE_0_1: { min: 0.0, max: 1.0 },
    DEFAULT_INT: { min: 0, max: 2147483647 },
    DEFAULT_FLOAT: { min: 0.0, max: 100.0 },
};

export const STEP_VALUES = {
    INTEGER: 1,
    SMALL_FLOAT: 0.01,
    LARGE_FLOAT: 0.1,
};

export const STRING_CONSTRAINTS = {
    MAX_LENGTH: 255,
};

export const BOOLEAN_VALUES = {
    TRUE: 'true',
    FALSE: 'false',
};

/**
 * Key pattern matchers for automatic range detection
 */
export const KEY_PATTERNS = {
    TIMEOUT_MS: (key) => key.includes('timeout') && key.includes('ms'),
    TTL_SECONDS: (key) => key.includes('ttl') && key.includes('seconds'),
    VECTOR_K: (key) => key.includes('vector_k'),
    THRESHOLD: (key) => key.includes('threshold'),
    DOWNLOADS_LIMIT: (key) => key.includes('downloads_limit'),
    MIN_SCORE: (key) => key.includes('min_score'),
    WEIGHT: (key) => key.includes('weight'),
    BOOST: (key) => key.includes('boost'),
    MULTIPLIER: (key) => key.includes('multiplier'),
    FACTOR: (key) => key.includes('factor'),
};

/**
 * Description patterns for detecting value ranges
 */
export const DESCRIPTION_PATTERNS = {
    RANGE_0_1: (desc) => desc.includes('(0-1)') || desc.includes('0 to 1') || desc.includes('threshold (0-1)'),
};

/**
 * Default values for system settings
 */
export const DEFAULT_SETTINGS = {
    concept_coverage_bonus_weight: '5',
    enable_query_decomposition: 'true',
    enable_query_decomposition_cache: 'true',
    free_tier_daily_downloads_limit: '5',
    full_query_boost: '10',
    min_entities_for_tier_scoring: '2',
    modified_phrase_boost: '5',
    modifier_boost: '2',
    opensearch_rescore_oversample_factor: '1',
    opensearch_tier_post_filter_threshold: '50.0',
    opensearch_vector_k: '5000',
    opensearch_vector_min_score: '0.675',
    opensearch_vector_timeout_ms: '45000',
    query_decomposition_cache_ttl_seconds: '86400',
    query_decomposition_threshold: '1',
    tag_coverage_bonus_multiplier: '1',
    tag_filter_mode: 'majority',
    tag_match_weight: '1.0',
    tier1_base_score: '1000.0',
    tier2_base_score: '500.0',
    tier3_base_score: '250.0',
    tier4_base_score: '100.0',
    tier5_base_score: '50.0',
    tier6_multiplier: '0.1',
    unmodified_entity_boost: '6',
    use_tag_aware_scoring: 'true',
    use_tier_scoring: 'true',
    vector_similarity_weight: '2',
};
